'use client';

/**
 * Create Layout Client
 *
 * Client-side wrapper for the create character page.
 * Uses AppLayoutWrapper for consistent navbar + sidebar styling.
 */
import { AppLayoutWrapper } from '~/_components/app-layout-wrapper';

export function CreateLayoutClient({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AppLayoutWrapper showCoinBalance={true}>
      {/* Transparent and no inner scroll — the whole page scrolls, and the
          AppLayoutWrapper gradient shows through as one seamless backdrop (an
          overflow container here cut content and left a scroll seam). */}
      <div className="flex-1">{children}</div>
    </AppLayoutWrapper>
  );
}
